import { Tooltip } from "@material-ui/core";
import { observer } from "mobx-react-lite";
import React, { useEffect, useRef, useState } from "react";
import { compareDates } from "../../helpers/date.helper";
import { convertUrl } from "../../helpers/url.helper";
import { Countdown } from "../Countdown/Countdown";

export const Button = observer((props) => {
  const [disabled, setDisabled] = useState(true);
  const { settings, environment, orders } = props;
  const { link, texts, target, useTimer, startDateTime, endDateTime, timerShadow, showZeroes, showTitle, hidden, showTooltip = false } = settings;
  const timerRef = useRef();
  useEffect(() => {
    buttonTimeHandler();
    return () => {
      if (timerRef.current) {
        clearInterval(timerRef.current);
      }
    };
  }, []);

  useEffect(() => {
    buttonTimeHandler();
  }, [startDateTime, endDateTime]);

  const navigate = () => (link ? window.open(convertUrl(link, orders !== undefined && orders.length > 0 ? orders[0] : null), target || "_blank") : null);
  const buttonTimeHandler = () => {
    if (!useTimer) {
      return setDisabled(false);
    }

    if (timerRef.current) clearInterval(timerRef.current);

    if (startDateTime || endDateTime) {
      if (startDateTime && disabled && compareDates(startDateTime)) {
        if (!endDateTime || (endDateTime && +new Date() < +new Date(endDateTime))) {
          setDisabled(false);
        }
      } else if (endDateTime && +new Date() > +new Date(endDateTime)) {
        setDisabled(true);
      } else {
        timerRef.current = setInterval(() => {
          if (startDateTime && disabled && compareDates(startDateTime)) {
            if (!endDateTime || (endDateTime && +new Date() < +new Date(endDateTime))) {
              setDisabled(false);
              if (!endDateTime) clearInterval(timerRef.current);
            }
          }
          if (endDateTime && +new Date() > +new Date(endDateTime)) {
            setDisabled(true);
            clearInterval(timerRef.current);
          }
        }, 10000);
      }
    } else {
      setDisabled(false);
    }
  };
  if (hidden) return null;
  return (
    <>
      <div>
        {useTimer && startDateTime ? (
          <div className="cms-countdown">
            <Countdown {...props} settings={{ datetime: startDateTime, timerShadow, showZeroes, showTitle }} />
          </div>
        ) : null}
        <div className="wrap button" style={{ display: "flex" }}>
          {showTooltip ?
          <Tooltip title={convertUrl(link, orders !== undefined && orders.length > 0 ? orders[0] : null)}>
            <button disabled={disabled} onClick={navigate} className="cms-button">
              {texts[environment.lang]}
            </button>
          </Tooltip>
          :
          <button disabled={disabled} onClick={navigate} className="cms-button">
          {texts[environment.lang]}
        </button>}
        </div>
      </div>
    </>
  );
});
